import {video} from '../video/player';
import {banner} from '../display/banner';
import {publisherSignals} from '../shared/context';
const loader=document.currentScript as HTMLScriptElement|null;
const scripts = loader?.dataset.unit ? [loader] : [];
for (const script of scripts) {
  if(script.dataset.felixMounted) continue; script.dataset.felixMounted='true';
  const base=new URL(script.src).origin; const host=document.createElement('div'); host.style.minHeight='1px'; script.after(host);
  let started=false;
  const start=async()=>{if(started)return; started=true; try {
    const response=await fetch(`${base}/api/units/${encodeURIComponent(script.dataset.unit!)}`,{signal:AbortSignal.timeout(5000)});
    if(!response.ok)throw new Error('Unknown unit'); const unit=await response.json();
    const signals=await publisherSignals(unit.id);if(signals===null){host.remove();return;}
    if(unit.type==='video')await video(host,unit,base,signals); else await banner(host,unit,base,signals,script.dataset.placement??'in-article');
  }catch(error){host.remove(); console.warn('[FelixAds]',error);window.dispatchEvent(new CustomEvent('felixads:event',{detail:{unit:script.dataset.unit,event:'sdkerror',message:String(error)}}));}};
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();void start();}},{threshold:0.1});observer.observe(host);}else void start();
}
